import styles from "./CustomPanel.module.scss";
import clsx from "clsx";
export const CustomPanel = ({
  slot,
  children,
}: {
  slot: "topLeft" | "belowFullscreenControl";
  children: React.ReactNode;
}) => {
  return (
    <div className={clsx(styles.customPanel, styles[`slot-${slot}`])}>
      {children}
    </div>
  );
};
